import React from 'react';

import { LoginPage } from '@eluve/feature-login';

import { appConfig } from '../config';

export const LoginPageWrapper: React.FC = () => {
  return (
    <LoginPage
      isMagicLinkAppFlagEnabled={appConfig.VITE_ENABLE_MAGIC_LINK_LOGIN}
      isMicrosoftLoginAppFlagEnabled={appConfig.VITE_ENABLE_MICROSOFT_LOGIN}
      isEmailPasswordAuthEnabled={appConfig.VITE_ENABLE_EMAIL_PASSWORD_AUTH}
      isSocialAuthEnabled={appConfig.VITE_ENABLE_SOCIAL_AUTH}
      appType="web"
    />
  );
};
